import InputMask from "@amzn/meridian/input/mask";
import {
    ADTA_ASSET_TYPE,
    ADTF_ASSET_TYPE,
    ASL_ASSET_TYPE, AUTO_LOADER_ASSET_TYPE,
    BLUE_COLOR,
    CATCH_ALL_INSTALLATION_TYPES, INSTALLATION_TYPES, NO_PRINTER_ASSIGNED,
    ORANGE_COLOR,
    TESSERACT_ASSET_TYPE, UNASSIGN_PRINTER,
    DOT, SEMI_COLON, COLON,
    ZANCASORT_LOCATION_TYPES,
    ZANCASORT_LOCATION_SUB_TYPES,
    LOCATION_TYPE_SEPARATOR,
    VAPR_LOCATION_TYPES,
    VAPR_ORIENTATIONS,
    PICK_ITEM_TYPES,
    ZANCA_SORT_TIER_NAMES,
    STOW_STATION_TIERS,
    MERCURY_V2_PROTOCOL_ENABLED_STATIONS,
    SLAM_V1_4_PROTOCOL_ENABLED_STATIONS,
    ASL_INDUCT_TEST_PACKAGE_ENABLED_STATIONS,
    OPERATIONS
} from "./Constants";
import {
    chainWalk,
    getCurrentDate,
    getNodeId,
    getTestConfigKey,
    getUTRRegion,
    macFromParentAssetLabel
} from "./Util";
import {ledControllerColorOrder} from "./enums";
import {FEATURES, FeatureUtility, isNewZancaSortTestConfigEnabled} from "./FeatureUtility";

export const MAC_MASK = new InputMask(
    '^^:^^:^^:^^:^^:^^',
    {
        formatChars: {
            '^': '[0-9a-fA-F]'
        }
    }
);
export const DIVERT_CODE_MASK = new InputMask(
    '^^',
    {
        formatChars: {
            '^': '[0-9]'
        }
    }
);

const WANZL_CART_RECIPES = {
    NON_OV: ["WANZL_FOUR_BIN_ZERO_OV_TWO_LIDAR"],
    TWO_TIER_OV: ["WANZL_ZERO_BIN_TWO_OV_THREE_LIDAR"],
    ONE_TIER_OV: ["WANZL_ZERO_BIN_ONE_OV_THREE_LIDAR"],
    FLEX_RACK:  ["WANZL_EIGHT_BIN_ZERO_OV_THREE_LIDAR", "WANZL_FOUR_BIN_ONE_TOP_OV_THREE_LIDAR", "WANZL_FOUR_BIN_ONE_BOTTOM_OV_THREE_LIDAR"]
}

const HARTWALL_CART_RECIPES = {
    NON_OV: ["HARTWALL_FOUR_BIN_ZERO_OV_TWO_LIDAR"],
    TWO_TIER_OV: ["HARTWALL_ZERO_BIN_TWO_OV_THREE_LIDAR"],
    ONE_TIER_OV: ["HARTWALL_ZERO_BIN_ONE_OV_THREE_LIDAR"],
    FLEX_RACK: ["HARTWALL_EIGHT_BIN_ZERO_OV_THREE_LIDAR", "HARTWALL_FOUR_BIN_ONE_BOTTOM_OV_THREE_LIDAR", "HARTWALL_FOUR_BIN_ONE_TOP_OV_THREE_LIDAR"]
}

const IRSG_CART_RECIPES = {
    NON_OV: ["IRSG_FOUR_BIN_ZERO_OV_TWO_LIDAR"],
    TWO_TIER_OV: ["IRSG_ZERO_BIN_TWO_OV_THREE_LIDAR"],
    ONE_TIER_OV: ["IRSG_ZERO_BIN_ONE_OV_THREE_LIDAR"],
    FLEX_RACK: ["IRSG_EIGHT_BIN_ZERO_OV_THREE_LIDAR", "IRSG_FOUR_BIN_ONE_BOTTOM_OV_THREE_LIDAR", "IRSG_FOUR_BIN_ONE_TOP_OV_THREE_LIDAR"]
}

//Non OV Recipes that used in all regions
//WorldWideNonOVCartRecipes
const WW_NON_OV_CART_RECIPES = [
    "AMZL_NON_OV_COLUMN_TYPE2",
    ...WANZL_CART_RECIPES.NON_OV,
    ...HARTWALL_CART_RECIPES.NON_OV,
    ...IRSG_CART_RECIPES.NON_OV,
];

//Two tier OV Recipes that used in all regions
//WorldWideTwoTierOVCartRecipes
const WW_TWO_TIER_OV_CART_RECIPES = [
    ...WANZL_CART_RECIPES.TWO_TIER_OV,
    ...HARTWALL_CART_RECIPES.TWO_TIER_OV,
    ...IRSG_CART_RECIPES.TWO_TIER_OV,
];

//One Tier OV Recipes that used in all regions
//WorldWideOneTierOVCartRecipes
const WW_ONE_TIER_OV_CART_RECIPES = [
    ...WANZL_CART_RECIPES.ONE_TIER_OV,
    ...HARTWALL_CART_RECIPES.ONE_TIER_OV,
    ...IRSG_CART_RECIPES.ONE_TIER_OV,
];

export const WW_FLEX_CART_RECIPES  = [
    ...WANZL_CART_RECIPES.FLEX_RACK,
    ...HARTWALL_CART_RECIPES.FLEX_RACK,
    ...IRSG_CART_RECIPES.FLEX_RACK
]

export const SCANLESS_SUPPORTED_CART_RECIPES_NA = {
    NON_OV: WW_NON_OV_CART_RECIPES,
    TWO_TIER_OV: ["AMZL_OV_COLUMN_TYPE3", "AMZL_OV_COLUMN_TYPE2", ...WW_TWO_TIER_OV_CART_RECIPES],
    ONE_TIER_OV: ["AMZL_OV_COLUMN_TYPE1", ...WW_ONE_TIER_OV_CART_RECIPES],
    FLEX_RACK: [...WW_FLEX_CART_RECIPES]
}

export const SCANLESS_SUPPORTED_CART_RECIPES_JP = {
    NON_OV: WW_NON_OV_CART_RECIPES,
    TWO_TIER_OV: ["AMZL_OV_COLUMN_TYPE3", ...WW_TWO_TIER_OV_CART_RECIPES],
    ONE_TIER_OV: ["AMZL_OV_COLUMN_TYPE2", ...WW_ONE_TIER_OV_CART_RECIPES],
    FLEX_RACK: [...WW_FLEX_CART_RECIPES]
}

export function getAisleNamePattern() {
    const region = getUTRRegion();
    if (region === "NA") {
        return PATTERNS.AISLE_NA
    } else if (region === "EU") {
        return PATTERNS.AISLE_EU
    }
    return PATTERNS.AISLE_FE
}

export const AISLE_NAME = {
    NA: "A-1",
    EU: "A1",
    FE: "A1"
}

export const SCANLESS_SUPPORTED_CART_RECIPES_EU = {
    NON_OV: WW_NON_OV_CART_RECIPES,
    TWO_TIER_OV: ["AMZL_OV_COLUMN_TYPE3", ...WW_TWO_TIER_OV_CART_RECIPES],
    ONE_TIER_OV: ["AMZL_OV_COLUMN_TYPE2", ...WW_ONE_TIER_OV_CART_RECIPES],
    FLEX_RACK: [...WW_FLEX_CART_RECIPES]
}

export const LIDAR_CONTROLLER_TYPES = ["Maxilux", "Skylark"]

export const PROTOCOLS = {
    ADTA: ['sort', 'sort-2021-v1', 'sort-mercury-2.04', 'adta-a2c-v1'],
    ADTF: ['matrix-v1', 'matrix-v2'],
    ASL: ['slam', 'slam-2021-v1', 'slam-2021-v1.3', 'slam-2026-v1.4', 'asl-a2c-v1'],
    ZANCASORT: ['asrs-a2c-v1'],
    TESSERACT: ['asrs-a2c-v1'],
    AUTO_RETRIEVER: ['asrs-a2c-v1'],
    ASML: ['asml-tcp-ip-v1'],
    AUTO_LOADER: ['rufus-a2c-v1'],
    VAPR: ['asrs-a2c-v1'],
}

const SITE_GATED_PROTOCOLS = {
    'matrix-v2': MERCURY_V2_PROTOCOL_ENABLED_STATIONS,
    'slam-2026-v1.4': SLAM_V1_4_PROTOCOL_ENABLED_STATIONS,
}

function isProtocolAvailableAtSite(protocol) {
    const allowedStations = SITE_GATED_PROTOCOLS[protocol];
    return !allowedStations || allowedStations.includes(getNodeId());
}

export function getAdtfProtocols() {
    return PROTOCOLS.ADTF.filter(isProtocolAvailableAtSite);
}

export function getAslProtocols() {
    return PROTOCOLS.ASL.filter(isProtocolAvailableAtSite);
}

// Read at call time, like the protocol gates above: the station comes from the page URL.
export function isAslInductTestPackageEnabled() {
    return ASL_INDUCT_TEST_PACKAGE_ENABLED_STATIONS.includes(getNodeId());
}

export const VENDOR_INFO_KEYS = {
    VENDOR: ["actemium", "agito", "ami", "bastian", "bluecrest", "caljan", "cmc", "dematic", "duravant", "fives", "galam", "hokusho", "igem", "impact_automation", "intellistore", "intralox", "kengic", "koerber", "lac", "leonardo", "lewco", "meikikou", "mhs", "okura", "orion", "raymond", "retiina", "sit", "ssi", "tgw", "ulma", "vanderlande", "wayzim", "zancaner", "other"],
    SPEC_VERSION: ["EU_deployment_v1.0", "EU_pilot_v1", "EU_pilot_v2", "EU_prod_v1", "EU_prod_v2", "EU_v0.5", "EU_v1.0", "EU_v1.1", "EU_v1.5", "EU_v2", "EU_v3", "EU_v3.1", "FE_v0", "FE_v1", "FE_v3", "FE_v4", "NA_2021", "NA_2022", "NA 2023", "NA_2024", "NA_2025", "NA_v1.5", "pilot", "WW_TRD_v0.5", "WW_TRD_v1.0", "WW_TRD_v1.1", "WW_v1.0", "WW_v2.0", "other"],
    SORTER_TYPE: ["ami_swivel", "cmc_swivel", "honeywell_transnorm", "igem_swivel", "intralox", "narrow_belt", "orion_swivel", "modsort", "saiet_swivel", "other"],
    HAMPER_VENDOR: ["agito", "ami", "caljan", "cannon", "cmc", "fives", "ia", "iec", "interoll", "lewco", "meikikou", "muvro", "preceed", "tiffin", "other"],
    HAMPER_VERSION: ["EU_v0.5", "EU_v1.0", "EU_v2.0", "EU_v2.1", "EU_pilot_v1", "NA_v1.0", "NA_v1.5", "NA_v2.0", "NA_v2.3", "NA_v2.4", "NA_2022", "FE_v0", "FE_v0.1", "FE_v0.2", "FE_v1", "FE_v2", "FE_v3", "WW_v1.0", "other"],
    INCOMING_AUTO_SINGULATED: ["true", "false"],
    INCOMING_AUTO_SORTED: ["true", "false"]
};

export const VENDOR_DISPLAY_VALUES = {
    "actemium": "Actemium",
    "agito": "AGITO",
    "ami": "AMI",
    "bastian": "Bastian",
    "bluecrest": "Bluecrest",
    "caljan": "Caljan",
    "cmc": "CMC",
    "dematic": "Dematic",
    "duravant": "Duravant",
    "fives": "Fives",
    "galam": "Galam Robotics",
    "hokusho": "Hokusho",
    "igem": "iGEM",
    "impact_automation": "Impact Automation",
    "intellistore": "intellistore",
    "intralox": "Intralox",
    "kengic": "Kengic",
    "koerber": "Koerber",
    "lac": "LAC",
    "leonardo": "Leonardo",
    "lewco": "Lewco",
    "meikikou": "Meikikou",
    "mhs": "MHS",
    "okura": "Okura",
    "orion": "Orion",
    "raymond": "Raymond",
    "retiina": "Retiina",
    "sit": "Sit",
    "ssi": "SSI",
    "tgw": "TGW",
    "ulma": "ULMA",
    "vanderlande": "Vanderlande",
    "wayzim": "Wayzim",
    "zancaner": "Zancaner",
    "other": "Other"
}

export const SPEC_VERSION_DISPLAY_VALUES = {
    "EU_deployment_v1.0": "EU Deployment v1.0",
    "EU_pilot_v1": "EU Pilot v1",
    "EU_pilot_v2": "EU Pilot v2",
    "EU_prod_v1": "EU Prod v1",
    "EU_prod_v2": "EU Prod v2",
    "EU_v0.5": "EU v0.5",
    "EU_v1.0": "EU v1.0",
    "EU_v1.1": "EU v1.1",
    "EU_v1.5": "EU v1.5",
    "EU_v2": "EU v2",
    "EU_v3": "EU v3",
    "EU_v3.1": "EU v3.1",
    "FE_v0": "FE v0",
    "FE_v1": "FE v1",
    "FE_v3": "FE v3",
    "FE_v4": "FE v4",
    "NA_2021": "NA 2021",
    "NA_2022": "NA 2022",
    "NA 2023": "NA 2023",
    "NA_2024": "NA 2024",
    "NA_2025": "NA 2025",
    "NA_v1.5": "NA v1.5",
    "pilot": "Pilot",
    "WW_TRD_v0.5": "WW TRD v0.5",
    "WW_TRD_v1.0": "WW TRD v1.0",
    "WW_TRD_v1.1": "WW TRD v1.1",
    "WW_v1.0": "WW v1.0",
    "WW_v2.0": "WW v2.0",
    "other": "Other"
};

export const SORTER_TYPE_DISPLAY_VALUES = {
    "ami_swivel": "AMI Swivel",
    "cmc_swivel": "CMC Swivel",
    "honeywell_transnorm": "Honeywell Transnorm",
    "igem_swivel": "iGEM Swivel",
    "intralox": "Intralox ARB S7000",
    "narrow_belt": "Narrow Belt",
    "orion_swivel": "Orion Swivel",
    "modsort": "Regal Dual-Modsort",
    "saiet_swivel": "SAIET Swivel",
    "other": "Other"
};

export const HAMPER_VENDOR_DISPLAY_VALUES = {
    "agito": "AGITO",
    "ami": "AMI",
    "caljan": "Caljan",
    "cannon": "Cannon",
    "cmc": "CMC",
    "fives": "Fives",
    "ia": "Impact Automation",
    "iec": "IEC",
    "interoll": "Interoll",
    "lewco": "Lewco",
    "meikikou": "Meikikou",
    "muvro": "Muvro",
    "preceed": "Preceed",
    "tiffin": "Tiffin",
    "other": "Other"
};

export const HAMPER_VERSION_DISPLAY_VALUES = {
    "EU_v0.5": "EU v0.5",
    "EU_v1.0": "EU v1.0",
    "EU_v2.0": "EU v2.0",
    "EU_v2.1": "EU v2.1",
    "EU_pilot_v1": "EU Pilot v1",
    "NA_v1.0": "NA v1.0",
    "NA_v1.5": "NA v1.5",
    "NA_v2.0": "NA v2.0",
    "NA_v2.3": "NA v2.3",
    "NA_v2.4": "NA v2.4",
    "NA_2022": "NA 2022",
    "FE_v0": "FE v0",
    "FE_v0.1": "FE v0.1",
    "FE_v0.2": "FE v0.2",
    "FE_v1": "FE v1",
    "FE_v2": "FE v2",
    "FE_v3": "FE v3",
    "WW_v1.0": "WW v1.0",
    "other": "Other"
}

export const INCOMING_AUTO_SINGULATED_DISPLAY_VALUES = {
    "true": "Yes",
    "false": "No"
}

export const INCOMING_AUTO_SORTED_DISPLAY_VALUES = {
    "true": "Yes",
    "false": "No"
};

export const PATTERNS = {
    NAME: /^[A-Za-z0-9 -;]{1,50}$/,
    SLAM: /^slam-2021-v1\.[0-9]$/,
    DESTINATION: /^[A-Za-z0-9_]{1,50}$/,
    MAC: /^([0-9a-fA-F]{2}[:]){5}([0-9a-fA-F]{2})$/,
    MAC_MASK: /([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})/,
    BAY_ID: /^[A-Za-z0-9 _@.#&+-|]{1,50}$/,
    CONTAINER_TYPE: /^[A-Za-z0-9_-]{1,20}$/,
    CONTAINER_LABEL: /^([A-Z])(-)?([1-9])$/,
    BAG_LABEL: /^[A-Z][-A-Z0-9_]{0,19}$/,
    DEVICE_ID: /^[A-Z0-9]{1,4}$/,
    // VAPR allows longer device IDs than the other device types (which keep DEVICE_ID, 1-4).
    VAPR_DEVICE_ID: /^[A-Z0-9]{1,6}$/,
    PORT: /^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
    CLUSTERS: /^([A-Z]|(([A-Z];)*[A-Z]))$/,
    LOCATION: /^([A-Z]|(([A-Z];)*[A-Z]))$|^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3}){0,2}$|^[A-Za-z0-9]$|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$|^([A-Z],[0-9]+,[A-Z])(;[A-Z],[0-9]+,[A-Z])*$/,
    STOW_STATION_LOCATION: /^([A-Z]#[12])(;[A-Z]#[12])*$/,
    CATCH_ALL_LOCATION: /^$|^([A-Z]|(([A-Z];)*[A-Z]))$|^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3}){0,2}$|^[A-Za-z0-9]$|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$/,
    SLIDE_LOCATION_RANGE: /^([A-Z]|(([A-Z];)*[A-Z]))$|^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3}){0,2}$|^[A-Za-z0-9]$|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$|^([A-Z],[0-9]+,[A-Z])(;[A-Z],[0-9]+,[A-Z])*$|^([A-Z].L[0-9]{0,3}.[A-Z]{2})([;:][A-Z].L[0-9]{0,3}.[A-Z]{2})*$/,
    TEST_SCANNABLE: /^([A-Za-z_\-0-9]{11,})(;[A-Za-z_\-0-9]{11,})*$/,
    TEST_PACKAGE_ID: /^([A-Za-z_\-0-9]{11,})$/,
    SORT_ZONE: /(([A-Z])(\d*)-(\d)([A-Z]))|(([A-Z])-(\d*).(\d)([A-Z]))|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$/,
    DIVERT_CODE: /^[1-9][0-9]$/,
    SHORT_STRING: /^[A-Za-z0-9 '_]{1,20}/,
    LONG_STRING: /^[A-Za-z0-9 '_]{1,200}/,
    DATE: /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/,
    AISLE_NA: /^([A-Z]-\d{1,2})$/,
    AISLE_EU: /^([A-Z]\d{1,2})$/,
    AISLE_FE: /^([A-Z]\d{1,2})$/,
    INTEGER: /^[1-9]\d*$/,
    AISLE: /^([A-Z]-(\d*))$|^([A-Z](\d*))$/,
    SORT_LOCATION: /^([A-Z]-\d{1,2}\.[A-Z0-9]{1,2}|[A-Z]\d{1,2}-[A-Z0-9]{1,2})$/,
    BAG_LIST: /^[A-Z0-9-_]+(;[A-Z0-9-_]+)*$/,
    BIN_LIST: /^(RU\.[0-9]{3})(;RU\.[0-9]{3})*$/,
    TIER_NAME: /^[A-Za-z0-9_]+$/,
    ZANCASORT_LOCATION_ID: /^[A-Za-z0-9][A-Za-z0-9_-]{0,49}$/,
    VAPR_LOCATION_LABEL: /^[A-Za-z0-9][A-Za-z0-9_-]{0,49}$/,
    VAPR_SCENE_BRIGHTNESS_LEVEL: /^(10|[0-9])$/
}

export const ZERO_TO_255
    = "(\\d{1,2}|(0|1)\\"
    + "d{2}|2[0-4]\\d|25[0-5])";

// Regex for a digit from 0 to 255 and
// followed by a dot, repeat 4 times.
// this is the regex to validate an IP address.
export const IP_ADDRESS_PATTERN
    = new RegExp("^" + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "$");

export function isValidEntry(entry, regex) {
    const value = regex.test(entry);
    return value;
}

/**
 * Checks that an IPv4 address can be assigned to an LED controller - rejects 0.x, loopback,
 * link-local, multicast and 255.255.255.255.
 *
 * @param ip an address that already matches IP_ADDRESS_PATTERN
 * @return true when the address is assignable
 */
export function isAssignableControllerIp(ip) {
    const [first, second] = String(ip).split('.').map(Number);
    return first !== 0 && first !== 127 && first < 224 && !(first === 169 && second === 254);
}

/**
 * Validates an LED controller IP - well-formed IPv4 that can be assigned to a controller.
 *
 * @param ip the IP address to validate
 * @return true when the address is valid
 */
export function isValidControllerIp(ip) {
    return isValidEntry(ip, IP_ADDRESS_PATTERN) && isAssignableControllerIp(ip);
}

/**
 * Strips leading zeros from each octet, e.g. 010.074.000.015 becomes 10.74.0.15.
 *
 * @param ip the IPv4 address to normalize
 * @return the normalized address, or the input unchanged when it is not a valid IPv4 address
 */
export function normalizeIpAddress(ip) {
    return isValidEntry(ip, IP_ADDRESS_PATTERN)
        ? ip.split('.').map(octet => String(parseInt(octet, 10))).join('.')
        : ip;
}

export function validateUniqueEntries(entries) {
    const uniqueEntries = new Set(entries);
    return (entries.length === uniqueEntries.size);
}

// A package id can belong to one test package only. Returns the first of scannables that a row in
// testPackages already holds, with that row's sort zone, or null. Rows deleted in the draft don't count.
export function findScannableConflict(scannables, testPackages) {
    for (const testPackage of testPackages) {
        if (testPackage.operation === OPERATIONS.DELETE) continue;
        const scannable = scannables.find((entry) => testPackage.scannables.includes(entry));
        if (scannable) {
            return {scannable, sortZone: testPackage.sortZone};
        }
    }
    return null;
}

/**
 * Validates an optional parentAssetLabel. Left blank it passes - not every asset hangs off a parent - but a value
 * that is present has to be a real mac address, or the consuming service silently never resolves the parent asset.
 *
 * @param parentAssetLabel the stored parentAssetLabel, possibly null or empty
 * @return true when absent, or present and a valid mac address
 */
export function isValidOptionalParentAssetLabel(parentAssetLabel) {
    return !parentAssetLabel || isValidEntry(macFromParentAssetLabel(parentAssetLabel), PATTERNS.MAC);
}

export function areAllInputsFulfilled(stateValues) {

    if(!stateValues.deviceType) return false;
    let areInputsFilled = stateValues.name
        && stateValues.mac
        && stateValues.ip
        && stateValues.port
        && stateValues.vendorAttributes
        && stateValues.vendorAttributes.vendor
        && stateValues.vendorAttributes.spec_version;

    if (stateValues.deviceType === 'slam') {
        return areInputsFilled
            && stateValues.deviceConfig.responsePort
            && stateValues.deviceConfig.inductLocation
            && stateValues.deviceConfig.userId;
    }

    areInputsFilled = areInputsFilled && stateValues.deviceConfig.id;

    if(stateValues.deviceType.includes("sort")) {
        return areInputsFilled
            && stateValues.vendorAttributes.sorter_type
            && stateValues.vendorAttributes.hamper_vendor
            && stateValues.vendorAttributes.hamper_version
            && stateValues.vendorAttributes.incoming_auto_singulated
            && stateValues.vendorAttributes.incoming_auto_sorted;
    }

    if(stateValues.deviceType.includes("matrix")) {
        return areInputsFilled && stateValues.vendorAttributes.sorter_type;
    }

    return areInputsFilled;
}

export function areAllInputsFulfilledForLidarController(stateValues) {
    let lidarControllerConfig = stateValues.lidarControllerConfig;
    return lidarControllerConfig
        && LIDAR_CONTROLLER_TYPES.includes(lidarControllerConfig.lidarControllerType)
        && lidarControllerConfig.macAddress
        && lidarControllerConfig.ipAddress
        && lidarControllerConfig.startAisleLabel
        && lidarControllerConfig.endAisleLabel
        && lidarControllerConfig.nonOVCartRecipe
        && lidarControllerConfig.twoTierOVCartRecipe;
}

export function areAllInputsFulfilledForMonitoring(stateValues) {
    return stateValues.startTime && stateValues.endTime && stateValues.reason && stateValues.startTime <= stateValues.endTime;
}

export function areAllInputsFulfilledForConfig(config, assetType) {
    if (assetType === ADTA_ASSET_TYPE) {
        if (CATCH_ALL_INSTALLATION_TYPES.includes(config.installation.type)) {
            return config.bayId && config.installation.type;
        } else {
            return config.bayId && config.installation.type && (config.installation.locations);
        }
    }  if (assetType === AUTO_LOADER_ASSET_TYPE) {
        if (CATCH_ALL_INSTALLATION_TYPES.includes(config.installation.type)) {
            return config.destination && config.installation.type
        } else {
            return config.destination && config.installation.type && (config.installation.locations);
        }
    } else if (assetType === ADTF_ASSET_TYPE) {
        if (['miss', 'jackpot', 'ov', INSTALLATION_TYPES.FRAGILE.value].includes(config.installation.type)) {
            return config.destinationId && config.sorterId && config.installation.type;
        } else {
            return config.destinationId && config.sorterId &&
                config.installation.type && config.installation.locations;
        }
    } else if (assetType === TESSERACT_ASSET_TYPE) {
        return config.containerType && config.containerLabel;
    } else if (assetType === ASL_ASSET_TYPE)     {
        return config.divertCode && config.clusters;
    }
}

export function areAllInputsFulfilledForZancaSortTestPackage(stowTestPackage) {
    const isNewTestConfigEnabled = isNewZancaSortTestConfigEnabled();

    if (isNewTestConfigEnabled) {
        return stowTestPackage.scannables
            && stowTestPackage.destination
            && Array.isArray(stowTestPackage.containerList) && (stowTestPackage.containerList.length > 0)
    } else {
        return stowTestPackage.scannables && stowTestPackage.destination;
    }
}

export function areAllInputsFulfilledForTesseractTestPackage(stowTestPackage) {
    return stowTestPackage.trackingId && stowTestPackage.scannables && stowTestPackage.destination;
}

export function areAllInputsFulfilledForTestPackage(sorterTestPackage) {
        return sorterTestPackage.scannables && sorterTestPackage.sortZone;
}

/**
 * Whether the stacked stow mock test fields (bag and tier) apply to a given ADTF.
 */
export function isStackedStowTestApplicable(sorterDestinations) {
    return isNewZancaSortTestConfigEnabled()
        && (sorterDestinations || []).some((config) =>
            chainWalk(() => config.installation.type, null) === INSTALLATION_TYPES.STOW_STATION.value);
}

/**
 * Finds a test package row that claims a different tier for the same bag as {@code candidate}.
 */
export function findConflictingBagTier(existingTestPackages, candidate) {
    if (!candidate.bag || !candidate.tier) return null;
    return (existingTestPackages || []).find((existing) =>
        existing.bag === candidate.bag
        && existing.tier
        && existing.tier !== candidate.tier) || null;
}

/**
 * Validates the optional stacked stow fields of a single test package row. Absent values are
 * always acceptable; a tier that is present must be one the consumers can resolve. The modal
 * supplies tier from a dropdown so it cannot be wrong there, but a CSV upload can.
 */
export function areStackedStowTestFieldsWellFormed(sorterTestPackage) {
    return !sorterTestPackage.tier
        || STOW_STATION_TIERS.some(({value}) => value === sorterTestPackage.tier);
}

export function validateNewAslDevice(stateValues) {
    if(getAslProtocols().includes(stateValues.deviceType)) {
        if(stateValues.deviceType === 'slam') {
            return areAllInputsFulfilled(stateValues) &&
                isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
                isValidEntry(stateValues.mac, PATTERNS.MAC) &&
                isValidEntry(stateValues.port, PATTERNS.PORT) &&
                isValidEntry(stateValues.deviceConfig.responsePort, PATTERNS.PORT) &&
                isValidEntry(stateValues.deviceConfig.inductLocation, PATTERNS.SHORT_STRING) &&
                isValidEntry(stateValues.deviceConfig.userId, PATTERNS.SHORT_STRING) &&
                isValidEntry(stateValues.name, PATTERNS.NAME) &&
                VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
                VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);
        } else {
            return areAllInputsFulfilled(stateValues) &&
                isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
                isValidEntry(stateValues.mac, PATTERNS.MAC) &&
                isValidEntry(stateValues.port, PATTERNS.PORT) &&
                isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
                isValidEntry(stateValues.name, PATTERNS.NAME) &&
                VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
                VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);
        }
    } else {
        return false;
    }
}

export function validateNewAdtaDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        PROTOCOLS.ADTA.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version) &&
        VENDOR_INFO_KEYS.SORTER_TYPE.includes(stateValues.vendorAttributes.sorter_type) &&
        VENDOR_INFO_KEYS.HAMPER_VENDOR.includes(stateValues.vendorAttributes.hamper_vendor) &&
        VENDOR_INFO_KEYS.HAMPER_VERSION.includes(stateValues.vendorAttributes.hamper_version) &&
        VENDOR_INFO_KEYS.INCOMING_AUTO_SINGULATED.includes(stateValues.vendorAttributes.incoming_auto_singulated) &&
        VENDOR_INFO_KEYS.INCOMING_AUTO_SORTED.includes(stateValues.vendorAttributes.incoming_auto_sorted);
}

const LED_CONTROLLER_PORT_COUNT_PATTERN = /-(\d+)-port/;

/**
 * Number of ports an LED controller type supports, read from its config name,
 * e.g. "advatek-32-port-unicast-ledcontroller-config" -> 32, "falcon-48-port-unicast-ledcontroller-config" -> 48.
 *
 * @param ledControllerType the site's LED controller type config name
 * @return the port count, or null when the name carries none (no limit is applied then)
 */
export function getMaxPortsForLedControllerType(ledControllerType) {
    const match = typeof ledControllerType === 'string' ? ledControllerType.match(LED_CONTROLLER_PORT_COUNT_PATTERN) : null;
    return match ? parseInt(match[1], 10) : null;
}

/**
 * @return true when port is a valid port number and, if maxPorts is known, does not exceed it
 */
export function isValidLedPortNumber(port, maxPorts) {
    return isValidEntry(port, PATTERNS.PORT) && (isNull(maxPorts) || parseInt(port, 10) <= maxPorts);
}

/**
 * Aisles are assigned consecutive ports from startPort, so the last one (startPort + aisleCount - 1) must fit too.
 *
 * @return true when every port in the range fits within maxPorts, or maxPorts is unknown
 */
export function isLedPortRangeWithinLimit(startPort, aisleCount, maxPorts) {
    return isNull(maxPorts) || parseInt(startPort, 10) + parseInt(aisleCount, 10) - 1 <= maxPorts;
}

export function validateNewLedController(stateValues, maxPorts) {
    const isIpCaptureEnabled = FeatureUtility.getFeatureStatus(FEATURES.IS_LED_CONTROLLER_IP_CAPTURE_ENABLED);
    return !isNull(stateValues) &&
        hasAllNonNullFields(stateValues.ledControllerConfig) &&
        isValidEntry(stateValues.ledControllerConfig.macAddress, PATTERNS.MAC) &&
        (!isIpCaptureEnabled || isValidControllerIp(stateValues.ledControllerConfig.ipAddress)) &&
        isValidEntry(stateValues.ledControllerConfig.startAisleLabel, getAisleNamePattern()) &&
        isValidLedPortNumber(stateValues.ledControllerConfig.startPortNumber, maxPorts) &&
        isValidEntry(stateValues.ledControllerConfig.aisleType, PATTERNS.LONG_STRING) &&
        isValidEntry(stateValues.ledControllerConfig.aisleCount, PATTERNS.INTEGER) &&
        isLedPortRangeWithinLimit(stateValues.ledControllerConfig.startPortNumber,
            stateValues.ledControllerConfig.aisleCount, maxPorts);
}

export function validateAddAislesForLedController(stateValues, maxPorts) {
    return !isNull(stateValues) &&
        hasAllNonNullFields(stateValues.ledControllerConfig) &&
        isValidEntry(stateValues.ledControllerConfig.startAisleLabel, getAisleNamePattern()) &&
        isValidLedPortNumber(stateValues.ledControllerConfig.startPortNumber, maxPorts) &&
        isValidEntry(stateValues.ledControllerConfig.aisleType, PATTERNS.LONG_STRING) &&
        isValidEntry(stateValues.ledControllerConfig.aisleCount, PATTERNS.INTEGER) &&
        isLedPortRangeWithinLimit(stateValues.ledControllerConfig.startPortNumber,
            stateValues.ledControllerConfig.aisleCount, maxPorts);
}

export function validateUpdateLedController(stateValues, mac, maxPorts) {
    return !isNull(stateValues) &&
        stateValues.length > 0 &&
        stateValues.every(stateValue => { return hasAllNonNullFields(stateValue) })
        && stateValues.every(value =>  {
            return (isValidEntry(value.aisleName, getAisleNamePattern()) &&
                isValidEntry(value.aisleType, PATTERNS.LONG_STRING) &&
                isValidLedPortNumber(value.portNumber, maxPorts))
        }) &&
        isValidEntry(mac, PATTERNS.MAC);
}

/**
 * @return true when any of the given ports is a number above maxPorts. Used to pick the port-limit alert over the
 * generic one.
 */
export function hasLedPortAboveLimit(ports, maxPorts) {
    return !isNull(maxPorts) && ports.some(port => parseInt(port, 10) > maxPorts);
}

function isNull(value) {
    return value === null || value === undefined;
}

export function hasAllNonNullFields(obj) {
    if (isNull(obj) || Object.keys(obj).length === 0) return false;

    return Object.values(obj).every(value => !isNull(value));
}

export function validateLedDefaultValues(defaultValues) {
    return !isNull(defaultValues) &&
        hasAllNonNullFields(defaultValues.ledControllerDefaultValues) &&
        isValidEntry(defaultValues.ledControllerDefaultValues.ledControllerType, PATTERNS.LONG_STRING) &&
        isValidEntry(defaultValues.ledControllerDefaultValues.aisleType, PATTERNS.LONG_STRING) &&
        Object.values(ledControllerColorOrder).includes(defaultValues.ledControllerDefaultValues.colorOrder)
}

export function validateNewLidarController(stateValues) {
    return areAllInputsFulfilledForLidarController(stateValues) &&
        isValidEntry(stateValues.lidarControllerConfig.ipAddress, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.lidarControllerConfig.macAddress, PATTERNS.MAC) &&
        isValidEntry(stateValues.lidarControllerConfig.startAisleLabel, PATTERNS.AISLE) &&
        isValidEntry(stateValues.lidarControllerConfig.endAisleLabel, PATTERNS.AISLE);
}

export function validateNewAdtfDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        getAdtfProtocols().includes(stateValues.deviceType) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version) &&
        VENDOR_INFO_KEYS.SORTER_TYPE.includes(stateValues.vendorAttributes.sorter_type);
}

export function validateNewZancaSortDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        PROTOCOLS.ZANCASORT.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version) &&
        isValidOptionalParentAssetLabel(stateValues.parentAssetLabel)
}

export function validateNewAutoLoaderDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        PROTOCOLS.AUTO_LOADER.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)
}

export function validateNewTesseractDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        PROTOCOLS.TESSERACT.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)
}

export function validateNewAutoRetrieverDevice(stateValues) {
    return  areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        PROTOCOLS.AUTO_RETRIEVER.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)
}

export function validateNewAsmlComponentDevice(stateValues) {
    if(PROTOCOLS.ASML.includes(stateValues.deviceType)) {
        return areAllInputsFulfilled(stateValues) &&
            isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
            isValidEntry(stateValues.mac, PATTERNS.MAC) &&
            isValidEntry(stateValues.port, PATTERNS.PORT) &&
            isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
            isValidEntry(stateValues.name, PATTERNS.NAME) &&
            VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
            VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);
    } else {
        return false;
    }
}

export function validateNewAsmlDevice(stateValues) {
    return isValidEntry(stateValues.inductCameraMac, PATTERNS.MAC) &&
        (isValidEntry(stateValues.printerMac, PATTERNS.MAC) || stateValues.printerMac === UNASSIGN_PRINTER || stateValues.printerMac === NO_PRINTER_ASSIGNED)
}
export function validateNewControllerDevice(mac, ip, name) {
    return mac && ip && name && isValidEntry(ip, IP_ADDRESS_PATTERN) && isValidEntry(mac, PATTERNS.MAC) && isValidEntry(name, PATTERNS.NAME)
}

export function checkModalValidationsForMonitoring(stateValues) {
    return areAllInputsFulfilledForMonitoring(stateValues) &&
        isValidEntry(stateValues.reason, PATTERNS.LONG_STRING)
}

export function checkModalValidationsForConfig(stateValues, mac, assetType) {
    if (assetType === ADTA_ASSET_TYPE) {
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            isValidEntry(stateValues.bayId, PATTERNS.BAY_ID) &&
            (['jackpot', 'recirculation','problem_solve'].includes(stateValues.installation.type)
                || (CATCH_ALL_INSTALLATION_TYPES.includes(stateValues.installation.type)
                    && isValidEntry(stateValues.installation.locations, PATTERNS.CATCH_ALL_LOCATION))
                || isValidEntry(stateValues.installation.locations, PATTERNS.LOCATION)
                || ((FeatureUtility.getFeatureStatus(FEATURES.IS_MULTIPLE_BULKY_SLIDES_FOR_DROP_TO_CART_ENABLED))
                    && INSTALLATION_TYPES.BULKY.value.includes(stateValues.installation.type)
                    && isValidEntry(stateValues.installation.locations, PATTERNS.SLIDE_LOCATION_RANGE)
                    && isValidRange(stateValues.installation.locations))
                || ((FeatureUtility.getFeatureStatus(FEATURES.IS_MULTIPLE_FRAGILE_SLIDES_ENABLED_FOR_SSD))
                    && INSTALLATION_TYPES.FRAGILE.value.includes(stateValues.installation.type)
                    && isValidEntry(stateValues.installation.locations, PATTERNS.SLIDE_LOCATION_RANGE) // uses same regex as bulky
                    && isValidRange(stateValues.installation.locations))
                || (FeatureUtility.getFeatureStatus(FEATURES.IS_BIN_INSTALLATION_TYPE_ENABLED)
                    && INSTALLATION_TYPES.BIN.value.includes(stateValues.installation.type)
                    && isValidEntry(stateValues.installation.locations, PATTERNS.BIN_LIST))
            ) && isValidEntry(mac, PATTERNS.MAC);
    } else if (assetType === ADTF_ASSET_TYPE) {
        // TODO: Add regex pattern for destinationId and sorterId
        const locationPattern = stateValues.installation.type === INSTALLATION_TYPES.STOW_STATION.value
            ? PATTERNS.STOW_STATION_LOCATION : PATTERNS.LOCATION;
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            (
                ['miss', 'jackpot', 'ov', INSTALLATION_TYPES.FRAGILE.value].includes(stateValues.installation.type)  ||
                isValidEntry(stateValues.installation.locations, locationPattern)
            ) &&
            isValidEntry(mac, PATTERNS.MAC);
    } else if (assetType === ASL_ASSET_TYPE) {
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            isValidEntry(stateValues.divertCode, PATTERNS.DIVERT_CODE) &&
            isValidEntry(stateValues.clusters, PATTERNS.CLUSTERS) &&
            isValidEntry(mac, PATTERNS.MAC);
    } else if (TESSERACT_ASSET_TYPE === assetType) {
        return areAllInputsFulfilledForConfig(stateValues, assetType)
            && isValidEntry(stateValues.containerType, PATTERNS.CONTAINER_TYPE)
            && isValidEntry(stateValues.containerLabel, PATTERNS.CONTAINER_LABEL)
            && isValidEntry(mac, PATTERNS.MAC);
    } else if (assetType === AUTO_LOADER_ASSET_TYPE) {
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            isValidEntry(stateValues.destination, PATTERNS.DESTINATION) &&
            ([INSTALLATION_TYPES.SIDELINE.value].includes(stateValues.installation.type)
                || (CATCH_ALL_INSTALLATION_TYPES.includes(stateValues.installation.type)
                    && isValidEntry(stateValues.installation.locations, PATTERNS.CATCH_ALL_LOCATION))
                || isValidEntry(stateValues.installation.locations, PATTERNS.LOCATION)) &&
            isValidEntry(mac, PATTERNS.MAC);
    }
}

export function validateAddDivertConfigModal(stateValues, mac, assetType) {
    return areAllInputsFulfilledForConfig(stateValues, assetType)
        && isValidEntry(stateValues.divertCode, PATTERNS.DIVERT_CODE)
        && stateValues.clusters.every((cluster) => isValidEntry(cluster, PATTERNS.CLUSTERS))
        && isValidEntry(mac, PATTERNS.MAC);
}

export function checkZancaSortAddTestPackageModalValidations(stateValues) {
    if (isNewZancaSortTestConfigEnabled()) {
        return areAllInputsFulfilledForZancaSortTestPackage(stateValues)
            && stateValues.scannables.every((entry) => isValidEntry(entry, PATTERNS.TEST_SCANNABLE))
            && isValidEntry(stateValues.destination, PATTERNS.SORT_LOCATION)
            && stateValues.containerList.every((container) => isValidEntry(container, PATTERNS.BAG_LABEL));
    } else {
        return areAllInputsFulfilledForZancaSortTestPackage(stateValues)
            && stateValues.scannables.every((entry) => isValidEntry(entry, PATTERNS.TEST_SCANNABLE))
            && isValidEntry(stateValues.destination, PATTERNS.BAG_LABEL);
    }
}

export function checkTesseractAddTestPackageModalValidations(stateValues) {
    return areAllInputsFulfilledForTesseractTestPackage(stateValues)
        && isValidEntry(stateValues.trackingId, PATTERNS.TEST_PACKAGE_ID)
        && stateValues.scannables.every((entry) => isValidEntry(entry, PATTERNS.TEST_PACKAGE_ID))
        && stateValues.scannables.includes(stateValues.trackingId)
        && stateValues.scannables.length <= 2
        && isValidEntry(stateValues.destination, PATTERNS.CONTAINER_LABEL)
}

export function checkModalValidationsForTestPackage(stateValues) {
        return areAllInputsFulfilledForTestPackage(stateValues)
            && stateValues.scannables.every((entry) => isValidEntry(entry, PATTERNS.TEST_SCANNABLE))
            && isValidEntry(stateValues.sortZone, PATTERNS.SORT_ZONE)
}

export const checkModalValidationsForAutoloaderTestPackage = (config) => {
    return Array.isArray(config.scannables) && config.scannables.length > 0 &&
        config.scannables.every(scannable => isValidEntry(scannable, PATTERNS.TEST_SCANNABLE))
        && !isNaN(config.length) && config.length > 0
        && !isNaN(config.height) && config.height > 0
        && !isNaN(config.width) && config.width > 0
        && !isNaN(config.weight) && config.weight > 0
        && isValidEntry(config.sortZone, PATTERNS.SORT_ZONE) ;
};

function isValidTimestamp(timestamp) {
    const newTimestamp = new Date(Number(timestamp)).getTime();
    return isNumeric(newTimestamp);
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function checkDeviceMonitoringEnabled(deviceMonitoringStartTime, deviceMonitoringEndTime) {
    if(!isValidTimestamp(deviceMonitoringStartTime) || !isValidTimestamp(deviceMonitoringEndTime)) {
        return {isMonitoringEnabled: true, isValidEntry: false};
    }
    if(getCurrentDate() < deviceMonitoringStartTime || getCurrentDate() > deviceMonitoringEndTime) {
        return {isMonitoringEnabled: true, isValidEntry: true};
    }
    return {isMonitoringEnabled: false, isValidEntry: true};
}

export function getMonitoringStatusDetails(deviceMonitoring) {
    return (deviceMonitoring.isValidEntry ?
        (deviceMonitoring.isMonitoringEnabled ?
            {monitoringStatusColor: BLUE_COLOR, monitoringStatusId: 'device.monitoringEnabled', monitoringStatusDefaultMessage: 'Enabled'}:
            {monitoringStatusColor: ORANGE_COLOR, monitoringStatusId: 'device.monitoringDisabled', monitoringStatusDefaultMessage: 'Disabled'})
        : {monitoringStatusColor: BLUE_COLOR, monitoringStatusId: 'device.invalidEntry', monitoringStatusDefaultMessage: 'Invalid Entry'})
}

export function checkModalValidationsForTriggeringMHEValidation(stateValues, dateTimeInput) {
    return !isStartTimeLaterThanEndTime(stateValues) && !isDurationMoreThanTwelveHours(stateValues)
        && isFromAndToDateTimeEntered(dateTimeInput);
}

export function isStartTimeLaterThanEndTime(stateValues) {
    return stateValues.startTime >= stateValues.endTime;
}

export function isDurationMoreThanTwelveHours(stateValues) {
    return Math.abs(stateValues.endTime - stateValues.startTime) > 12 * 60 * 60 * 1000;
}

export function isFromAndToDateTimeEntered(dateTimeInput) {
    return dateTimeInput.valueDateFrom.length > 0 && dateTimeInput.valueDateTo.length > 0 &&
        dateTimeInput.valueTimeFrom.length > 0 && dateTimeInput.valueTimeTo.length > 0;
}

/**
 * Check if scannables are unique.
 * @param {Array} scannables - List of scannables to check
 * @param {Array} existingData - Existing configurations
 * @param {string} currentKey - Current configuration key (for edit case)
 * @returns {Array} - List of duplicate scannables found, empty if none
 */
export function checkDuplicateScannables(scannables, existingData, currentKey) {
    return scannables.filter(scannable =>
        existingData.some(entry =>
            entry.scannables.includes(scannable) &&
            getTestConfigKey(entry.scannables) !== currentKey
        )
    );
}

/**
 * Check if containers are mapped to unique destination/sort zone.
 * @param {Array} containers - List of containers to check
 * @param {string} destination - Destination/sort zone
 * @param {Array} existingData - Existing configurations
 * @param {string} currentKey - Current configuration key (for edit case)
 * @returns {Array} - List of containers with conflicts, empty if none
 */
export function checkContainerDestinationConflicts(containers, destination, existingData, currentKey) {
    try {
        const containerToDestinationMap = new Map();

        existingData.forEach(entry => {
            if (getTestConfigKey(entry.scannables) !== currentKey) {  // Skip current entry if editing
                if (entry.containerList && Array.isArray(entry.containerList)) {
                    entry.containerList.forEach(container => {
                        if (container && entry.destination) {
                            containerToDestinationMap.set(container, entry.destination);
                        }
                    });
                }
            }
        });

        // Find containers that are already assigned to different destination
        return containers.filter(container => {
            const existingDestination = containerToDestinationMap.get(container);
            return existingDestination && existingDestination !== destination;
        });
    } catch (error) {
        console.error('Error in container to destination validation', error);
        return [];
    }
}

export function hasUnavailableFloor(floorSorterConfig, floorsForSlide) {
    const availableFloors = new Set();
    floorSorterConfig.forEach(config => {
        config.installation.locations.forEach(location => {
            availableFloors.add(location);
        });
    });

    for (const floorForSlide of floorsForSlide) {
        if (!availableFloors.has(floorForSlide)) {
            return false;
        }
    }
    return true;
}

export function isValidRange(locationString) {
    const locations = locationString.split(SEMI_COLON);

    for (let location of locations) {
        const locationList = location.split(COLON);

        if (locationList.length > 2) {
            return false;
        }

        if (locationList.length === 2) {
            if (!isValidRangePair(locationList[0], locationList[1])) {
                return false;
            }
        }
    }

    return true;
}

function isValidRangePair(start, end) {
    const startParts = start.split(DOT);
    const endParts = end.split(DOT);

    if (startParts.length !== 3 || endParts.length !== 3) {
        return false;
    }

    if (startParts[0] !== endParts[0]) {
        return false;
    }

    if (startParts[2] !== endParts[2]) {
        return false;
    }

    if (!startParts[1].startsWith('L') || !endParts[1].startsWith('L')) {
        return false;
    }

    const startNum = parseInt(startParts[1].slice(1), 10);
    const endNum = parseInt(endParts[1].slice(1), 10);

    if (isNaN(startNum) || isNaN(endNum) || startNum >= endNum) {
        return false;
    }

    return true;
}

export function parseLocationType(locationType) {
    if (!locationType) {
        return {type: "", subType: ""};
    }
    const separatorIndex = locationType.lastIndexOf(LOCATION_TYPE_SEPARATOR);
    if (separatorIndex === -1) {
        return {type: locationType, subType: ""};
    }
    return {
        type: locationType.substring(0, separatorIndex),
        subType: locationType.substring(separatorIndex + 1)
    };
}

export function buildLocationType(type, subType) {
    if (!type) return "";
    return subType ? type + LOCATION_TYPE_SEPARATOR + subType : type;
}

/**
 * Validates a ZancaSort location configuration.
 * Checks that:
 *  - locationId is non-empty and matches the shared location id format
 *  - the parsed type is one of the allowed ZANCASORT_LOCATION_TYPES
 *  - TETRIS_STATION carries a valid sub type (A/B), while other types carry none
 * @param {Object} config - Configuration object with locationId and locationType properties
 * @returns {boolean} - true if valid, false if invalid
 */
export function validateZancaSortLocationConfig(config) {
    if (!config.locationId || !config.locationType) {
        return false;
    }

    if (!isValidZancaSortLocationId(config.locationId)) {
        return false;
    }

    const {type, subType} = parseLocationType(config.locationType);

    const validLocationTypes = Object.keys(ZANCASORT_LOCATION_TYPES);
    if (!validLocationTypes.includes(type)) {
        return false;
    }

    if (type === ZANCASORT_LOCATION_TYPES.TETRIS_STATION.value) {
        const validSubTypes = Object.keys(ZANCASORT_LOCATION_SUB_TYPES);
        if (!subType || !validSubTypes.includes(subType)) {
            return false;
        }
    } else if (subType) {
        return false;
    }

    return true;
}

export function isValidZancaSortLocationId(locationId) {
    if (!locationId || locationId.trim() === "") return false;
    return PATTERNS.ZANCASORT_LOCATION_ID.test(locationId);
}

export function isValidVaprLocationLabel(label) {
    if (!label || label.trim() === "") return false;
    return PATTERNS.VAPR_LOCATION_LABEL.test(label);
}

export function validateVaprLocationConfig(config, allowMissingOrientation = false) {
    if (!config || !config.label || !config.locationType) {
        return false;
    }
    if (!isValidVaprLocationLabel(config.label)) {
        return false;
    }
    if (!Object.values(VAPR_LOCATION_TYPES).some(type => type.value === config.locationType)) {
        return false;
    }
    if (!config.orientation) {
        return allowMissingOrientation;
    }
    return Object.values(VAPR_ORIENTATIONS).some(o => o.value === config.orientation);
}

/**
 * Validates a single ZancaSort tier configuration entry. The tier name must be one of
 * the allowed tier names, see ZANCA_SORT_TIER_NAMES.
 * @param {Object} config - { tierName, capacity, startLevel, endLevel }
 * @returns {boolean} - true if valid, false if invalid
 */
export function validateZancaSortTierConfig(config) {
    if (!ZANCA_SORT_TIER_NAMES.includes(config.tierName)) return false;
    if (!Number.isInteger(config.capacity) || config.capacity <= 0) return false;
    if (!Number.isInteger(config.startLevel) || config.startLevel < 1) return false;
    if (!Number.isInteger(config.endLevel) || config.endLevel < 1) return false;
    if (config.startLevel > config.endLevel) return false;

    return true;
}

/**
 * Checks for overlapping level ranges across tier configurations.
 * @param {Array} tierConfigs - Array of { tierName, capacity, startLevel, endLevel }
 * @returns {Object|null} - null if no overlap, or { tier1, tier2 } describing the conflicting tiers
 */
export function checkTierConfigLevelOverlap(tierConfigs) {
    for (let i = 0; i < tierConfigs.length; i++) {
        for (let j = i + 1; j < tierConfigs.length; j++) {
            const a = tierConfigs[i];
            const b = tierConfigs[j];
            // Ranges overlap if one starts before the other ends
            if (a.startLevel <= b.endLevel && b.startLevel <= a.endLevel) {
                return { tier1: a.tierName, tier2: b.tierName };
            }
        }
    }
    return null;
}

export function validateLocationMappingRow(destination, type, locations, existingRows, isEdit) {
    const DESTINATION_REGEX = /^[a-zA-Z][a-zA-Z0-9_\-.]{0,49}$/;

    if (!destination || !destination.trim()) {
        return {id: "locationmapping.error.destination_required"};
    }
    if (!DESTINATION_REGEX.test(destination.trim())) {
        return {id: "locationmapping.error.destination_invalid"};
    }
    if (!type || !PICK_ITEM_TYPES.includes(type)) {
        return {id: "locationmapping.error.type_required"};
    }
    if (!locations || locations.length === 0) {
        return {id: "locationmapping.error.locations_required"};
    }
    if (!isEdit) {
        const duplicate = existingRows.find(
            row => row.destination === destination.trim() && row.type === type
        );
        if (duplicate) {
            return {id: "locationmapping.error.duplicate", values: {destination: destination.trim(), type}};
        }
    }
    for (const loc of locations) {
        const conflict = existingRows.find(
            row => row.type === type &&
                   row.destination !== destination.trim() &&
                   row.locations && row.locations.includes(loc)
        );
        if (conflict) {
            return {id: "locationmapping.error.conflict", values: {pickPoint: loc, destination: conflict.destination, type}};
        }
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/components/util/Validations.js